import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type ValuationAgentsForPropertyQueryVariables = Types.Exact<{
    propertyId: Types.Scalars['Int'];
    transactionType: Types.TransactionType;
    v2Seed: Types.Scalars['String'];
    routeNewValuationBranchLogic?: Types.Maybe<Types.Scalars['Boolean']>;
}>;

export type ValuationAgentsForPropertyQuery = { __typename?: 'Query' } & {
    valuationBranches: Array<
        { __typename?: 'ValuationBranch' } & Pick<
            Types.ValuationBranch,
            | 'area'
            | 'branchDisplayName'
            | 'branchId'
            | 'logo'
            | 'outcode'
            | 'selected'
            | 'averageRentPrice'
            | 'averageSalePrice'
            | 'numberOfSaleListings'
            | 'numberOfRentListings'
            | 'address'
            | 'postcode'
        >
    >;
};

export const ValuationAgentsForPropertyDocument = gql`
    query valuationAgentsForProperty(
        $propertyId: Int!
        $transactionType: TransactionType!
        $v2Seed: String!
        $routeNewValuationBranchLogic: Boolean
    ) {
        valuationBranches(
            propertyId: $propertyId
            transactionType: $transactionType
            v2Seed: $v2Seed
            routeNewValuationBranchLogic: $routeNewValuationBranchLogic
        ) {
            area
            branchDisplayName
            branchId
            logo
            outcode
            selected
            averageRentPrice
            averageSalePrice
            numberOfSaleListings
            numberOfRentListings
            address
            postcode
        }
    }
`;

/**
 * __useValuationAgentsForPropertyQuery__
 *
 * To run a query within a React component, call `useValuationAgentsForPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useValuationAgentsForPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValuationAgentsForPropertyQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      transactionType: // value for 'transactionType'
 *      v2Seed: // value for 'v2Seed'
 *      routeNewValuationBranchLogic: // value for 'routeNewValuationBranchLogic'
 *   },
 * });
 */
export function useValuationAgentsForPropertyQuery(
    baseOptions: Apollo.QueryHookOptions<
        ValuationAgentsForPropertyQuery,
        ValuationAgentsForPropertyQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        ValuationAgentsForPropertyQuery,
        ValuationAgentsForPropertyQueryVariables
    >(ValuationAgentsForPropertyDocument, options);
}
export function useValuationAgentsForPropertyLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ValuationAgentsForPropertyQuery,
        ValuationAgentsForPropertyQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        ValuationAgentsForPropertyQuery,
        ValuationAgentsForPropertyQueryVariables
    >(ValuationAgentsForPropertyDocument, options);
}
export type ValuationAgentsForPropertyQueryHookResult = ReturnType<
    typeof useValuationAgentsForPropertyQuery
>;
export type ValuationAgentsForPropertyLazyQueryHookResult = ReturnType<
    typeof useValuationAgentsForPropertyLazyQuery
>;
export type ValuationAgentsForPropertyQueryResult = Apollo.QueryResult<
    ValuationAgentsForPropertyQuery,
    ValuationAgentsForPropertyQueryVariables
>;
